/**
 * TermsPage — route wrapper at /terms.
 * Renders full terms of use from legal/terms-copy.ts.
 * Public page — no gate required.
 */

import { TermsPolicyNext } from '../legal/terms-copy'

export default function TermsPage() {
  return <TermsPolicyNext />
}
